<div class="modal" id="addReqeustModal" tabindex="-1">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-body p-0">
        <div class="container-fluid p-0 bg-light-gray">
          <div class="row row-cols-1 gy-2 m-0">
            <div class="col mt-0 navbar-spacer">
              <app-navbar
                class="fixed-top"
                [isShowBackButton]="true"
                [preventDefaultGoBack]="true"
                (goBackCallback)="hide()"
              />
            </div>
            <div class="col bg-primary-white">
              <div class="container-fluid p-0">
                <div class="row row-cols-1 gy-4 m-0">
                  <div class="col">
                    <div class="fs-5 text-secondary-purple">
                      {{ 'app.leaveRequest.newLeaveRequest' | translate }}
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-2 text-secondary">
                      {{ 'app.leaveRequest.type' | translate }}
                    </div>
                    <div class="d-flex gap-2 justify-content-center">
                      <div class="btn-group w-100" role="group">
                        <input
                          [formControl]="type"
                          type="radio"
                          class="btn-check"
                          id="btn-check-casual"
                          name="btntyperadio"
                          value="casual"
                          autocomplete="off"
                        />
                        <label
                          class="btn btn-outline-primary w-100"
                          for="btn-check-casual"
                          >{{
                            'app.leaveRequest.leaveType.casual' | translate
                          }}</label
                        >
                        <input
                          [formControl]="type"
                          type="radio"
                          class="btn-check"
                          id="btn-check-sick"
                          name="btntyperadio"
                          value="sick"
                          autocomplete="off"
                        />
                        <label
                          class="btn btn-outline-primary w-100"
                          for="btn-check-sick"
                          >{{
                            'app.leaveRequest.leaveType.sick' | translate
                          }}</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-2 text-secondary">
                      {{ 'app.leaveRequest.pleaseSelectYourClass' | translate }}
                    </div>
                    <select [formControl]="classSelect" class="form-select">
                      @for (option of classOptions(); track $index) {
                        <option value="{{ option.value }}">
                          {{ option.label }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="col">
                    <div class="container px-4 pb-4">
                      <button
                        class="btn btn-primary w-100"
                        (click)="doAddRequest()"
                        [disabled]="
                          isDataLoading ||
                          isRequestAdding ||
                          classes().length === 0
                        "
                      >
                        {{ 'app.leaveRequest.submit' | translate }}
                        @if (isRequestAdding) {
                          <div
                            class="spinner-border text-light spinner-border-sm"
                          ></div>
                        }
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
